import { Dialog } from '@factorialco/f0-react/dist/experimental'
import {
  EngagementDuplicateSurveyDocument,
  EngagementSurveysDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  surveyId: number
  onSuccess: (newSurvey: { id: number }) => void
  onCancel: () => void
}

export function DuplicateSurveyDialog({ surveyId, onSuccess, onCancel }: Props) {
  const [duplicateSurvey] = useMutation(EngagementDuplicateSurveyDocument, {
    extractorFn: (data) => data.surveysMutations.duplicateSurveysSurvey,
    refetchQueries: [EngagementSurveysDataCollectionDocument],
  })

  return (
    <Dialog
      onClose={onCancel}
      actions={{
        primary: {
          label: i18n.t('common.duplicate'),
          variant: 'neutral',
          onClick: async () => {
            const response = await duplicateSurvey({
              variables: {
                surveyId,
              },
            })

            const handled = handleResult(response, () => {})
            const newSurvey = handled.success ? handled.data.survey : null

            if (newSurvey) {
              onSuccess(newSurvey)
            }
          },
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: onCancel,
        },
      }}
      header={{
        title: i18n.t('surveys.duplicate_survey_dialog.title'),
        description: i18n.t('surveys.duplicate_survey_dialog.description'),
        type: 'info',
      }}
      open
    />
  )
}
